import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MainService } from 'BaseServices/main-service';
import { UserService } from 'BaseServices/user-service';
import {
  ClientDetailDTO,
  ClientSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import {
  dialogData,
  genericDialogComponent,
} from 'projects/Assets/src/assets-base/Dialogs/genericDialog';
import { dialogInputTitleComponent } from 'src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from 'src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from 'src/app/buttons/delete-button/delete-button.component';

@Component({
  selector: 'app-client-dialog',
  imports: [
    dialogInputTitleComponent,
    FormsModule,
    SaveButtonComponent,
    DeleteButtonComponent,
  ],
  templateUrl: './client-dialog.component.html',
  styleUrls: [
    './client-dialog.component.css',
    '../../../../../../src/app/general-styles/dialogs.css',
  ],
})
export class ClientDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data = inject<dialogData<ClientDetailDTO[]>>(MAT_DIALOG_DATA);
  @Input() clientRequest!: ClientDetailDTO;

  currentUser = this.userService.currentUser;
  constructor(
    public override dialogRef: MatDialogRef<ClientDialogComponent>,
    public mainService: MainService,
    public userService: UserService
  ) {
    super(dialogRef);
    this.clientRequest = this.data.data[0];
  }

  ngOnInit(): void {}
  saveChanges() {
    if (this.clientRequest.id == 0) {
      this.mainService
        .add<ClientDetailDTO, ClientSummaryDTO>('Client', this.clientRequest)
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    } else {
      this.mainService
        .update<ClientDetailDTO, ClientSummaryDTO>(
          'Client',
          this.clientRequest
        )
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    }
  }

  deleteEntry() {
    if (!confirm("Er du sikker på at du vil slette aftalen?'")) {
      return;
    }
    this.mainService
      .delete('Client', this.clientRequest.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
